import type { GetBillingCyclePageResponse } from '@weft/api-definition';
import { GetBillingCyclePageResponseSchema } from '@weft/api-definition';
import type { WeftApi } from '@weft/client';
import { purge } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

type BillingCyclePagePayload = Parameters<WeftApi['getBillingCyclePage']>[0];

export function useBillingCyclePage(payload: BillingCyclePagePayload = {}, options?: CustomUseQueryOptions<GetBillingCyclePageResponse>) {
  const purgePayloadValues = purge(Object.values(payload));

  const billingCyclePageQuery = useQuery({
    queryKey: ['billing-cycle-page', ...purgePayloadValues],
    queryFn: async ({ signal }) => {
      const api = getPrivateApi();
      const getBillingCyclePageResponse = await api.getBillingCyclePage(payload, { signal });

      return GetBillingCyclePageResponseSchema.parse(getBillingCyclePageResponse);
    },
    keepPreviousData: true,
    ...options,
  });

  return billingCyclePageQuery;
}